import styled from "styled-components";

export const StyledExportButtonWrapper = styled.div`
  height: 100%;
  .export-btn {
    height: 100%;
    padding: 0;
    color: ${({theme}) => theme.brand.primary};
    font-size: 26px;
    border: 2px solid ${({theme}) => theme.brand.primary};
  }
`;